/**
 * Redirections des six anciennes pages fusionnées (LOT-H12-DOUBLONS).
 *
 * `/admin/team` et `/admin/all-users` ont fusionné en `/admin/users` (DA-032) ;
 * `/sms/templates` et `/emails/templates` en `/messaging/templates` ;
 * `/sms/providers` et `/emails/providers` en `/messaging/providers` (DA-047).
 * Les anciens chemins vivent dans des signets, des liens partagés et
 * l'historique des navigateurs : ils REDIRIGENT, ils ne cassent pas.
 *
 * Les anciennes pages E-MAIL redirigent vers l'onglet E-mail
 * (`?channel=email`) : un signet vers `/emails/templates` doit rouvrir des
 * modèles d'e-mail, pas l'onglet SMS par défaut.
 *
 * Les gardes de rôle ne sont pas dupliquées ici : les routes cibles portent
 * déjà leur `ProtectedRoute` — un agent qui suit un vieux signet aboutit
 * exactement où il aboutissait avant, sur le refus d'accès.
 *
 * `replace` : la redirection ne laisse pas d'entrée d'historique, sinon le
 * bouton « précédent » boucle (même décision que `legacyStatsRedirects`).
 *
 * Le helper est exporté — et non écrit en clair dans `App.tsx` — pour que
 * `legacyMergeRedirects.spec.tsx` monte les VRAIES routes de production.
 */
import { Navigate, Route } from 'react-router-dom'

/** Ancien chemin → nouvelle destination. */
export const LEGACY_MERGE_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  // L-NAV-7 — la page Utilisateurs est devenue « Équipe » (`/equipe`) : cible
  // directe, sans rebond par `/admin/users` (lui-même une redirection).
  { from: '/admin/team', to: '/equipe' },
  { from: '/admin/all-users', to: '/equipe' },
  { from: '/sms/templates', to: '/messaging/templates' },
  { from: '/emails/templates', to: '/messaging/templates?channel=email' },
  { from: '/sms/providers', to: '/messaging/providers' },
  { from: '/emails/providers', to: '/messaging/providers?channel=email' },
]

/** Routes à insérer dans l'arbre AUTHENTIFIÉ, avant le `*` de la 404. */
export function legacyMergeRedirects() {
  return LEGACY_MERGE_REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<Navigate to={to} replace />} />
  ))
}
